import axiosInstance from '../config/axios';
import { standardizeError } from '../utils/errorHandler';
import { api } from '../config/api';

const signIn = async (data) => {
  try {
    const res = await axiosInstance.post(api.adminLogin, data);
    return res.data;
  } catch (err) {
    throw standardizeError(err);
  }
}

const verifyToken = async () => {
  try {
    const res = await axiosInstance.get(api.adminVerifyToken);
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};

const updateTrafficStatus = async (data) => {
  try {
    const res = await axiosInstance.post(api.adminUpdateTrafficStatus, data);
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};

const speechReport = async (data) => {
  try {
    const res = await axiosInstance.post(api.adminSpeechReport, data);
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};

const getAllRegisterHealthFacilities = async () => {
  try{
    const res = await axiosInstance.get(api.getAllRegisterHealthFacilities);
    return res.data;
  }catch (error) {
    throw standardizeError(error);
  }
};

const getLicenseImage = async (license_img) => {
  try{
    const res = await axiosInstance.get(`${api.getLicenseImage}?license_img=${license_img}`,{
            responseType: "arraybuffer",
          });
    return res.data;
  }catch (error) {
    throw standardizeError(error);
  }
};

const updateRegisterState = async (_id,newState) => {
  try{
    const res = await axiosInstance.patch(`${api.updateRegisterState}?_id=${_id}&state=${newState}`);
    return res.data;
  }catch (error) {
    throw standardizeError(error);
  }
};

const createHealthFacility = async (data) => {
  try{
    const res = await axiosInstance.post(api.createHealthFacility,{},{params: data});
    return res.data;
  }catch (error) {
    throw standardizeError(error);
  }
};

const adminUserApi = {
  signIn,
  verifyToken,
  updateTrafficStatus,
  speechReport,
  getAllRegisterHealthFacilities,
  getLicenseImage,
  updateRegisterState,
  createHealthFacility
};

export default adminUserApi;
